import React from "react";
import "../../style/gameMaster/CreateMatch.scss";

const CreateMatch = () => {
  return <div>CreateMatch</div>;
};

export default CreateMatch;
